import { PostHogConfig } from 'posthog-js';

interface PostHogEnvironment {
  [key: string]: string | undefined;
  REACT_APP_PUBLIC_POSTHOG_ENABLED?: string;
  REACT_APP_PUBLIC_POSTHOG_HOST?: string;
  REACT_APP_PUBLIC_POSTHOG_KEY?: string;
}

export interface EnabledPostHogConfig {
  apiKey: string;
  options: Partial<PostHogConfig>;
}

const PLACEHOLDER_PATTERN = /^(todo|change[-_ ]?me|placeholder)/i;

export function getPostHogConfig(
  environment: PostHogEnvironment,
): EnabledPostHogConfig | null {
  if (environment.REACT_APP_PUBLIC_POSTHOG_ENABLED !== 'true') return null;

  const apiKey = environment.REACT_APP_PUBLIC_POSTHOG_KEY?.trim() ?? '';
  const host = environment.REACT_APP_PUBLIC_POSTHOG_HOST?.trim() ?? '';
  if (!apiKey || !host || PLACEHOLDER_PATTERN.test(apiKey)) return null;

  try {
    const url = new URL(host);
    if (url.protocol !== 'https:' || url.hostname === 'localhost') return null;
  } catch {
    return null;
  }

  return {
    apiKey,
    options: {
      api_host: host,
      autocapture: false,
      capture_pageleave: false,
      capture_pageview: false,
      disable_session_recording: true,
      opt_out_capturing_by_default: true,
      opt_out_persistence_by_default: true,
      person_profiles: 'identified_only',
      respect_dnt: true,
    },
  };
}
